import React, { useState } from "react";
import CloudStorage from "../../CloudStorage/CloudStorage";
import { Modal, ModalBody } from "reactstrap";
import { useNavigate } from "react-router-dom";

export default function OverallRatings({ modal, setModal }) {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const navigate = useNavigate();
  return (
    <div>
      <Modal isOpen={modal} keyboard={false} className="overall-rating">
        <div className="modal-head">
          <button
            onClick={() => setModal(false)}
            className="btn close-button ml-auto"
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              alt=""
            />
          </button>
        </div>
        <ModalBody>
          <div className="row align-items-center">
            <div className="col-md-7 text-center rate-left">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`}
                alt=""
              />
              <h1>Your feedback matters</h1>
              <p>
                Please provide your rating and feedback for your recent
                experience with Mohammed
              </p>
            </div>
            <div className="col-md-5 rate-right">
              <div className="rating review-star">
                <h5>Average rating</h5>
                <div className="star-sec">
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star disabled"></i>
                </div>
              </div>
              <div className="review-star">
                <p>Satisfaction rating </p>
                <div className="star-sec">
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star disabled"></i>
                </div>
              </div>
              <div className="review-star">
                <p>Execution rating </p>
                <div className="star-sec">
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star disabled"></i>
                </div>
              </div>
              <div className="review-star">
                <p>Overall experience </p>
                <div className="star-sec">
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star"></i>
                  <i className="fa-solid fa-star disabled"></i>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
        {/* <div className='modal-footer'>
          <button className='btn' onClick={() => { setModal(state => !state); navigate(`/${lan}/account/upgrademembership`) }}>See Full Profile</button>
        </div> */}
      </Modal>
    </div>
  );
}
